'use client';

import React from 'react';
import { StyledCtaBanner } from './MarketingBudgetTool.styles';

export const CtaBanner = () => {
  return (
    <StyledCtaBanner>
      <div className="banner-inner">
        <h2>Ready to get more from your marketing budget?</h2>
        <p>
          CommonNinja has 226+ widgets: charts, pricing tables, popups,
          all free to try. Works on any website, no coding needed.
        </p>
        <a className="banner-cta" href="/widgets">Browse all free widgets {'→'}</a>
      </div>
    </StyledCtaBanner>
  );
};
